import { Component } from 'react';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import { marketingNavigation } from '../../constants/marketing';
import PromobannersHeader from './containers/PromobannersHeader/PromobannersHeader';
import PromobannersList from './containers/PromobannersList/PromobannersList';
import { promobannerStore } from './store/promobannerStore';

export default class PromobannersScreen extends Component<{}, {}> {
  componentDidMount = () => {
    promobannerStore.fetchPromobanners(1);
  };

  render() {
    return (
      <>
        <ScreenHeader title="marketing_role" options={marketingNavigation()} />
        <PromobannersHeader />
        <PromobannersList />
      </>
    );
  }
}
